import React from 'react';

type KoobTileButtonProps = Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'className'
> & {
  icon: React.ReactNode;
  /** not part of the API (see packages/ui/README.md) — declared so a stray
   * one can be stripped below instead of clobbering the computed classes */
  className?: never;
};

/**
 * Square icon-over-label button, for "pick one of these actions" layouts
 * (e.g. a modal offering ways to create a trip). Lay tiles out at the call
 * site with a grid: `<div className="grid grid-cols-3 gap-4">`.
 */
const KoobTileButton = React.forwardRef<HTMLButtonElement, KoobTileButtonProps>(
  ({ icon, children, className, type = 'button', ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      className="flex aspect-square w-full cursor-pointer flex-col items-center justify-center gap-3 rounded-xl border border-solid border-input bg-background p-4 text-sm font-medium text-gray-700 shadow-sm transition-colors hover:border-brand hover:bg-brand/5 hover:text-brand focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50"
      {...props}
    >
      <span
        className="text-3xl [&_svg]:size-8 [&_svg]:shrink-0"
        aria-hidden="true"
      >
        {icon}
      </span>
      <span className="text-center leading-snug">{children}</span>
    </button>
  ),
);

KoobTileButton.displayName = 'KoobTileButton';

export default KoobTileButton;
